import { preSchoolsDropdown } from '@/pages/application/data'

export const constApfResidency = {
  child: [
    { value: 'DP(Dependant Pass)', label: 'Dependant’s Pass' },
    { value: 'STP(Student Pass)', label: 'Student Pass' },
    { value: 'LTVP(Long Term Visit Pass)', label: 'Long-Term Visit Pass' },
    { value: 'PR(Permanent Resident)', label: 'Permanent Resident' },
    { value: 'SC(Citizen)', label: 'Singapore Citizen' },
    { value: 'Diplomatic Pass', label: 'Diplomatic Pass' },
  ],
  parent: [
    { value: 'SC(Citizen)', label: 'Singapore Citizen' },
    { value: 'PR(Permanent Resident)', label: 'Singapore Permanent Resident' },
    { value: 'EP(Employment Pass)', label: 'Employment Pass' },
    { value: 'LTVP(Long Term Visit Pass)', label: 'Long Term Visit Pass' },
    { value: 'Foreigner', label: 'Foreigner' },
  ],
}

export const constApfMISResidency = {
  child: [
    { value: 'DP(Dependant Pass)', label: 'Dependant’s Pass' },
    { value: 'LTVP(Long Term Visit Pass)', label: 'Long-Term Visit Pass' },
    { value: 'PR(Permanent Resident)', label: 'Permanent Resident' },
    { value: 'SC(Citizen)', label: 'Singapore Citizen' },
    { value: 'Diplomatic Pass', label: 'Diplomatic Pass' },
    { value: 'STP(Student Pass)', label: 'Student Pass' },
    { value: 'Immigration Exemption Order', label: 'Immigration Exemption Order' },
  ],
  parent: [
    { value: 'SC(Citizen)', label: 'Singapore Citizen' },
    { value: 'PR(Permanent Resident)', label: 'Singapore Permanent Resident' },
    { value: 'EP(Employment Pass)', label: 'Employment Pass' },
    { value: 'LTVP(Long Term Visit Pass)', label: 'Long Term Visit Pass' },
    { value: 'Foreigner', label: 'Overseas / Live abroad' },
    { value: 'DP(Dependant Pass)', label: 'Dependant’s Pass' },
    { value: 'STP(Student Pass)', label: 'Student Pass' },
    { value: 'Diplomatic Pass', label: 'Diplomatic Pass' },
  ],
}

export const misApfDocumentChecklist = [
  {
    label: 'Copy of child’s passport',
    doc: 'doc_stuPassport',
  },
  {
    label: 'Copy of child’s immigration document',
    doc: 'doc_2',
  },
  {
    label: 'Copy of child’s birth certificate',
    doc: 'doc_stuBirthCert',
  },
  {
    label:
      'Copy of Child’s vaccination certificate (vaccination against Diphtheria and Measles is compulsory in Singapore.  Vaccination records are required for students under 12 years old) or CDA Certificate',
    doc: 'doc_stuVaccination',
  },
  {
    label: "Copy of father's passport",
    doc: 'doc_faPassport',
  },
  {
    label: "Copy of father's immigration document",
    doc: 'doc_6',
  },
  {
    label: 'Copy of mother’s passport',
    doc: 'doc_maPassport',
  },
  {
    label: 'Copy of mother’s immigration document',
    doc: 'doc_8',
  },
  {
    label: 'Photo of parents/guardian',
    doc: 'doc_9',
  },
  {
    label: 'Copy of child’s last 2 years school reports (translated in English)',
    doc: 'doc_10',
  },
  {
    label: 'Any medical, psychology reports and education evaluation reports (whichever is applicable)',
    doc: 'doc_11',
  },
]

export const requiredMisApfDocumentChecklist = ['doc_stuPassport', 'doc_faPassport', 'doc_maPassport', 'doc_stuBirthCert', 'doc_stuVaccination']

export const ebisApfDocumentChecklist = [
  {
    label: 'Copy of child’s passport',
    doc: 'doc_stuPassport',
  },
  {
    label: 'Copy of child’s immigration document',
    doc: 'doc_2',
  },
  {
    label: 'Copy of child’s birth certificate',
    doc: 'doc_stuBirthCert',
  },
  {
    label:
      'Copy of Child’s vaccination certificate (vaccination against Diphtheria and Measles is compulsory in Singapore.  Vaccination records are required for students under 12 years old) or CDA Certificate',
    doc: 'doc_stuVaccination',
  },
  {
    label: "Copy of father's passport",
    doc: 'doc_faPassport',
  },
  {
    label: "Copy of father's immigration document",
    doc: 'doc_6',
  },
  {
    label: 'Copy of mother’s passport',
    doc: 'doc_maPassport',
  },
  {
    label: 'Copy of mother’s immigration document',
    doc: 'doc_8',
  },
  {
    label: 'Photo of parents/guardian',
    doc: 'doc_9',
  },
  {
    label: 'Copy of child’s last 2 years school reports (translated in English)',
    doc: 'doc_10',
  },
  {
    label: 'Any medical, psychology reports and education evaluation reports (whichever is applicable)',
    doc: 'doc_11',
  },
]

export const requiredEbisApfDocumentChecklist = ['doc_stuPassport', 'doc_faPassport', 'doc_maPassport', 'doc_stuBirthCert', 'doc_stuVaccination']

export const appCustomContent = {
  declarationContent: {
    SCH201300000254:
      '(Please note that all students studying at EtonHouse International School are required by the SkillsFuture Singapore (SSG) to sign a Standard PEI-Student Contract. It is important that you understand the above declaration on late commencement prior to signing a Standard PEI-Student Contract.)',
    default:
      '(Please note that all students studying at EtonHouse International School are required by the SkillsFuture Singapore (SSG) to sign a Standard Student Contract. It is important that you understand the declaration below on late commencement prior to signing a Standard Student Contract.)',
  },
}

export const isPreschoolApplication = school => {
  return Object.values(preSchoolsDropdown).includes(school)
}
